import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ScrollAnimate } from '../components/ScrollAnimate';
import { SEO } from '../components/SEO';
import { getPostBySlug } from '../data/blogPosts';

const backLinkClass =
  'inline-flex text-base font-semibold text-[#0064E0] hover:underline';

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : undefined;

  if (!post) {
    return (
      <>
        <SEO
          title="Article Not Found — logNsec"
          description="The article you are looking for does not exist or has been moved."
        />
        <section className="bg-white px-5 py-20 md:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <ScrollAnimate>
              <h1 className="text-section">Page not found</h1>
              <p className="mt-6 text-body-site">
                We could not find an article matching that link.
              </p>
              <Link to="/blog" className={`${backLinkClass} mt-8`}>
                ← Back to Blog
              </Link>
            </ScrollAnimate>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <SEO
        title={`${post.title} — logNsec`}
        description={post.excerpt}
        canonical={`/blog/${post.slug}`}
      />
      <section className="bg-[#F5F5F5] px-5 py-12 md:px-8 md:py-16">
        <div className="mx-auto max-w-3xl">
          <ScrollAnimate>
            <Link to="/blog" className={backLinkClass}>
              ← Back to Blog
            </Link>
            <p className="mt-8 text-label-site text-[#65676B]">{post.category}</p>
            <h1 className="text-section mt-3">{post.title}</h1>
            <p className="mt-4 text-body-site">
              {post.date}
              <span className="mx-2 text-[#8A8D91]">·</span>
              {post.readTime}
            </p>
          </ScrollAnimate>
        </div>
      </section>

      <section className="bg-white px-5 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-3xl">
          <ScrollAnimate>
            <div className="space-y-6">
              {post.content.map((paragraph, i) => (
                <p key={i} className="text-body-site">
                  {paragraph}
                </p>
              ))}
            </div>
            <Link to="/blog" className={`${backLinkClass} mt-12 block`}>
              ← Back to Blog
            </Link>
          </ScrollAnimate>
        </div>
      </section>
    </>
  );
}
